import React, { Fragment } from 'react'
import { Intro, MultipleChoice } from 'cvs-core'

const data = {
  question:
    'Which statement accurately describes why it is important to critically observe your social media accounts?',
  inputType: 'radio',
  options: [
    {
      label:
        'Research shows that teens who see social media posts featuring vaping are more likely to use e-cigarettes.',
    },
    {
      label:
        'A short viewing of a social media post featuring e-cigarettes has no effect on a teen’s decision-making.',
    },
    {
      label:
        'Social media feeds filled with e-cigarette ads and posts have little impact on the number of teens who vape.',
    },
    {
      label:
        'The more time you spend interacting on social media, the more likely you are to use e-cigarettes.',
    },
  ],
}

const correctInput = {
  [data.question]: data.options[0].label,
}

const feedback = {
  success: {
    title: 'Great job!',
    body: '',
  },
  error: {
    title: 'That’s incorrect.',
    body: '',
  },
  retry: {
    title: 'Not quite, give it another try',
    body: '',
  },
}

export default {
  title: 'Question 2',
  path: '/challenge/question-2',
  content: (
    <Fragment>
      <Intro
        title="Question 2"
        direction="Select the item that best completes the statement."
      />
      <MultipleChoice
        data={data}
        correctInput={correctInput}
        feedback={feedback}
        score={10}
        partiallyCorrectScoring={true}
      />
    </Fragment>
  ),
}



// WEBPACK FOOTER //
// ./src/data/Challenge/Question2.js